import openModalAction from 'modules/modal/actions/open/index.js'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'

export default function openEditAccountAccountPropertyModalUserAction (data) {
  return dispatch => {
    dispatch(
      openModalAction(MODAL_ID.EDIT_ACCOUNT_PROPERTY, data)
    )
  }
}
